import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import BASE_URL from "../BASEURL";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserTie,
  faUsers,
  faEnvelopeOpenText,
  faImages,
} from "@fortawesome/free-solid-svg-icons";

export default function AdminDashboard() {
  const [totalProducts, setTotalProducts] = useState(0);
  const [totalGalleries, setTotalGallery] = useState(0);
  const [totalInquiries, setTotalInquiries] = useState(0);
  const [totalPersons, setTotalPersons] = useState(0);
  const [inquiries, setInquiries] = useState([]);
  const [loadingInquiries, setLoadingInquiries] = useState(true);
  const [loadingStats, setLoadingStats] = useState(true);

  useEffect(() => {
    fetch(`${BASE_URL}/api/stats`)
      .then((res) => res.json())
      .then((data) => {
        setTotalProducts(data.totalDesignations || 0);
        setTotalGallery(data.totalGalleries || 0);
        setTotalInquiries(data.totalInquiries || 0);
        setTotalPersons(data.totalPersons || 0);
        setLoadingStats(false);
      })
      .catch(console.error);
  }, []);

  useEffect(() => {
    fetch(`${BASE_URL}/api/inquiries`)
      .then((res) => res.json())
      .then((data) => {
        setInquiries(data);
        setLoadingInquiries(false);
      })
      .catch(console.error);
  }, []);

  return (
    <div className="p-4 sm:p-6">
      <h1 className="text-xl sm:text-2xl font-bold text-brandBlue mb-6">
        Admin Dashboard
      </h1>

      {/* STATS CARDS */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        <StatCard
          link="/admin/DesignationList"
          icon={faUserTie}
          color="bg-blue-600"
          title="Total Designations"
          value={loadingStats ? "..." : totalProducts}
        />

        <StatCard
          link="/admin/personList"
          icon={faUsers}
          color="bg-emerald-600"
          title="Total Persons"
          value={loadingStats ? "..." : totalPersons}
        />

        <StatCard
          link="/admin/InquiriesList"
          icon={faEnvelopeOpenText}
          color="bg-orange-500"
          title="Total Inquiries"
          value={loadingStats ? "..." : totalInquiries}
        />

        <StatCard
          link="/admin/GallaryList"
          icon={faImages}
          color="bg-purple-600"
          title="Total Photos"
          value={loadingStats ? "..." : totalGalleries}
        />
      </div>

      {/* RECENT INQUIRIES */}
      <div className="bg-white rounded-xl shadow border mt-8 p-4 sm:p-2">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
          <h2 className="text-lg font-semibold text-brandBlue">
            Recent Inquiries
          </h2>
          <Link
            to="/admin/InquiriesList"
            className="text-sm font-medium text-brandBlue hover:text-brandOrange"
          >
            View All →
          </Link>
        </div>

        {loadingInquiries ? (
          <p className="text-center text-gray-500 py-6">
            Loading inquiries...
          </p>
        ) : inquiries.length === 0 ? (
          <p className="text-center text-gray-500 py-6">
            No inquiries found
          </p>
        ) : (
          <>
            {/* Desktop Table */}
            <div className="hidden sm:block">
              <div className="overflow-x-auto">
                <table className="min-w-full text-sm">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">
                        Name
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">
                        Email
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">
                        Subject
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">
                        Date
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y">
                    {inquiries.slice(0, 5).map((inquiry) => (
                      <tr key={inquiry._id} className="hover:bg-gray-50">
                        <td className="px-4 py-3 font-medium">
                          {inquiry.name}
                        </td>
                        <td className="px-4 py-3 text-gray-600">
                          {inquiry.email}
                        </td>
                        <td className="px-4 py-3 text-gray-600 max-w-xs truncate">
                          {inquiry.subject}
                        </td>
                        <td className="px-4 py-3 text-gray-600 whitespace-nowrap">
                          {new Date(inquiry.createdAt).toLocaleDateString()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            {/* Mobile Cards */}
            <div className="block sm:hidden space-y-4">
  {inquiries.slice(0, 5).map((inquiry) => (
    <div
      key={inquiry._id}
      className="bg-white border rounded-xl p-4 shadow-sm"
    >
      <div className="flex justify-between items-start mb-1">
        <h3 className="font-semibold text-gray-900 text-sm">
          {inquiry.name}
        </h3>
      </div>
       

      <p className="text-xs text-gray-600 mb-1">
        <span className="font-medium text-gray-700">Email:</span>{" "}
        {inquiry.email}
      </p>

      <p className="text-xs text-gray-600 mb-1">
        <span className="font-medium text-gray-700">Subject:</span>{" "}
        {inquiry.subject}
      </p>
      <p className="text-xs text-gray-600 line-clamp-2 ">
        <span className="font-medium text-gray-700">Inquirie Created Date:</span>{" "}
       {new Date(inquiry.createdAt).toLocaleDateString()}
      </p>
    </div>
  ))}
</div>

          </>
        )}
      </div>
    </div>
  );
}

/* 🔹 Reusable Card Component */
const StatCard = ({ link, icon, color, title, value }) => (
  <Link to={link} className="block">
    <div className="bg-white rounded-xl p-5 shadow border flex items-center gap-4 hover:shadow-lg transition">
      <div className={`${color} text-white p-4 rounded-lg`}>
        <FontAwesomeIcon icon={icon} className="text-xl" />
      </div>
      <div>
        <p className="text-gray-500 text-sm">{title}</p>
        <h2 className="text-xl font-semibold">{value}</h2>
      </div>
    </div>
  </Link>
);
